import type { NewsItem } from '@/types';

export const news: NewsItem[] = [
  {
    id: 'n1',
    title: '《星际回声》全球首映口碑爆棚，被称为年度最值得期待的科幻巨制',
    summary:
      '上映首周即收获超高评价，《星际回声》以宏大的世界观与细腻的情感内核打动观众。导演顾长风表示，这部作品想探讨的始终是“人类如何与自己告别”。',
    date: '2025-10-12',
    category: '电影动态',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20film%20premiere%20red%20carpet%20event%20at%20night%20with%20deep%20navy%20background%20and%20warm%20amber%20spotlights%2C%20elegant%20dramatic%20lighting%2C%20blurred%20crowd%2C%20highly%20detailed%20photography%2C%20no%20text%2C%20premium%20editorial%20aesthetic&width=800&height=500&seq=fy-n1-cover&orientation=landscape',
  },
  {
    id: 'n2',
    title: '古装悬疑剧《长安夜行录》收官，观众直呼“意难平”',
    summary:
      '本季大结局播出后话题持续霸榜，剧中对人性与权力的刻画引发广泛讨论。片方透露，续作已在筹备之中，原班人马有望回归。',
    date: '2025-10-09',
    category: '剧集资讯',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20an%20ancient%20Chinese%20palace%20courtyard%20at%20night%20lit%20by%20rows%20of%20lanterns%2C%20deep%20navy%20and%20warm%20amber%20tones%2C%20atmospheric%20cinematic%20lighting%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20historical%20drama%20still&width=800&height=500&seq=fy-n2-cover&orientation=landscape',
  },
  {
    id: 'n3',
    title: '戛纳获奖纪录片《万物生长》确认引进，将于下月登陆院线',
    summary:
      '这部横跨五大洲拍摄的自然纪录电影凭借震撼的影像与深情的叙事斩获多项大奖，此次引进将包含特别制作的巨幕版本。',
    date: '2025-10-06',
    category: '电影动态',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20an%20ancient%20forest%20canopy%20with%20sunbeams%20and%20drifting%20mist%2C%20lush%20green%20with%20warm%20golden%20light%2C%20serene%20natural%20atmosphere%2C%20highly%20detailed%20photography%2C%20no%20text%2C%20nature%20documentary%20aesthetic&width=800&height=500&seq=fy-n3-cover&orientation=landscape',
  },
  {
    id: 'n4',
    title: '《苍穹之翼》第二季正式官宣，概念预告片发布',
    summary:
      '短短两分钟的预告片展示了全新的空中战场与升级的视觉效果，制片方表示第二季将在世界观上进一步拓展，聚焦“人机共存”这一命题。',
    date: '2025-10-02',
    category: '剧集资讯',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20massive%20futuristic%20aircraft%20in%20a%20glowing%20dark%20hangar%2C%20deep%20navy%20tones%20with%20warm%20orange%20accent%20lighting%2C%20dramatic%20tech%20atmosphere%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20sci-fi%20series%20still&width=800&height=500&seq=fy-n4-cover&orientation=landscape',
  },
  {
    id: 'n5',
    title: '秋冬档电影片单出炉：悬疑与温情题材强势领跑',
    summary:
      '多家片方陆续公布档期，悬疑片《迷雾之城》与爱情片《春潮渐起》被业内普遍看好，有望成为本季度票房与口碑的双料热门。',
    date: '2025-09-28',
    category: '行业观察',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20moody%20city%20skyline%20at%20dusk%20with%20deep%20navy%20clouds%20and%20warm%20amber%20lights%2C%20dramatic%20cinematic%20atmosphere%2C%20highly%20detailed%20photography%2C%20no%20text%2C%20editorial%20aesthetic&width=800&height=500&seq=fy-n5-cover&orientation=landscape',
  },
  {
    id: 'n6',
    title: '犯罪悬疑剧《罪案边缘》口碑逆袭，成年度现象级黑马',
    summary:
      '开播时不被看好的《罪案边缘》凭借扎实的剧本与克制的表演完成口碑逆袭，连续数周稳居热度榜前列，被观众称为“近年最好的悬疑剧之一”。',
    date: '2025-09-24',
    category: '剧集资讯',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20dim%20detective%20office%20with%20a%20corkboard%20full%20of%20red%20strings%20and%20photos%2C%20cold%20navy%20blue%20tones%20with%20warm%20amber%20lamp%20light%2C%20tense%20atmosphere%2C%20highly%20detailed%20photography%2C%20no%20text%2C%20series%20still&width=800&height=500&seq=fy-n6-cover&orientation=landscape',
  },
  {
    id: 'n7',
    title: '《追光者》原声大碟上线，多首插曲登顶音乐榜单',
    summary:
      '影片上映后，其温暖而克制的配乐广受好评。原声大碟正式上线后，主题曲与插曲迅速登上多个音乐平台榜单，成为又一例“电影未散、音乐先火”的作品。',
    date: '2025-09-20',
    category: '影视音乐',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20recording%20studio%20with%20a%20grand%20piano%20under%20warm%20spotlight%2C%20deep%20navy%20background%20with%20warm%20amber%20glow%2C%20intimate%20dramatic%20lighting%2C%20highly%20detailed%20photography%2C%20no%20text%2C%20editorial%20aesthetic&width=800&height=500&seq=fy-n7-cover&orientation=landscape',
  },
  {
    id: 'n8',
    title: '年代剧《山河故人》定档，三代人四十年变迁引期待',
    summary:
      '以一条老街、三代人的命运为主线的《山河故人》正式定档。片中细腻的年代质感与真实的情感表达，让不少观众称“光看预告就湿了眼眶”。',
    date: '2025-09-15',
    category: '剧集资讯',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20riverside%20town%20at%20golden%20dusk%20with%20an%20old%20stone%20bridge%20and%20reflections%2C%20warm%20sepia%20and%20deep%20navy%20tones%2C%20nostalgic%20lighting%2C%20highly%20detailed%20photography%2C%20no%20text%2C%20period%20drama%20still&width=800&height=500&seq=fy-n8-cover&orientation=landscape',
  },
];
